// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__2CIy0","expandIcon":"AccordionButton_expandIcon__xQLGS","expanded":"AccordionButton_expanded__3Bhut"};